import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'

export const StyledDropdownContainer = styled.View`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

export const StyledTriggerContainer = styled.View<{ disabled?: boolean; error?: boolean }>`
  height: 46px;
  flex-direction: row;
  align-items: center;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.elementsBorder : theme.colors.elementsBg};
  border-width: 1px;
  border-color: ${({ theme }) => theme.colors.elementsBorder};
  border-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const StyledTriggerText = styled(Typography).attrs({
  variant: 'bodyNormal',
})<{ hasValue: boolean; error?: boolean; disabled?: boolean }>`
  flex: 1;
  color: ${({ theme, hasValue, error, disabled }) => {
    if (disabled) return theme.colors.textDisabled
    if (error && !hasValue) return theme.colors.errorText
    return theme.colors.text
  }};
`

export const StyledIconContainer = styled.View<{ disabled?: boolean }>`
  margin-left: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const StyledDropdown = styled.View`
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  border-width: 1px;
  border-color: ${({ theme }) => theme.colors.elementsBorder};
  overflow: hidden;
  ${({ theme }) => theme.shadows.border};
  flex: 1;
`

export const StyledOption = styled.View<{ focused?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  background-color: ${({ theme, focused }) => {
    if (focused) return theme.colors.contrastElementBg
    return theme.colors.elementsBg
  }};
`

export const StyledSeparator = styled.View`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.elementsBorder};
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
`

export const StyledAddItem = styled.View<{ focused?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 11px ${({ theme }) => theme.metrics.baseMargin * 0.75}px 12px;
  background-color: ${({ theme, focused }) => {
    if (focused) return theme.colors.contrastElementBg
    return theme.colors.elementsBg
  }};
`

export const StyledWebScrollView = styled.ScrollView`
  flex: 1;
`
